import { useEffect } from 'react';

export const useCtrlShiftK = (handler: () => void) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.ctrlKey && event.shiftKey && event.key === 'K') {
        // eslint-disable-next-line no-console
        console.log(`Ctrl + Shift + K was pressed!`);
        handler();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handler]);
};
